// import React,{useState,useEffect} from "react";
// import "../Assests/Scss/CNFModel.scss";

// const CNFSubmit = (props) => {
//     const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));
//     const [WindowTime, SetWindowTime] = useState(0);
//     const SubmitTest = () => {
//         if (navigator.onLine) {
//             props.ConformModelCLose(false);
//         }
//     };
//     if(WindowTime === parseInt(process.env.REACT_APP_NEXTPAPERLOADINGTIME)){
//         SubmitTest();
//         props.changExam();
//     }
//     useEffect(() => {
//         const interval = setInterval(() => {
//             SetWindowTime((prevSeconds) => {
//                 const newSeconds = prevSeconds + 1;
//                 return newSeconds;
//             });
//         }, 1000);
//         return () => {
//             clearInterval(interval);
//         };
//     }, [])

//     const GetNextExam = () => {
//         switch (props.subjectname) {
//             case AssessmentData.subject1Name:
//                 return `${AssessmentData.subject2Name}`;
//             case AssessmentData.subject2Name:
//                 return `${AssessmentData.subject3Name}`;
//             default:
//                 return "";
//         }
//     };
//     return (
//         <div className="CNFSubmit-mainDiv dflex flexd-column alignitems">

//             {props.TextRelated ?
//                 <span> {process.env.REACT_APP_ASSESSMENTSUBMIT} <b>{props.subjectname}</b> Assessment. {props.subjectname.toLowerCase() === AssessmentData.subject3Name.toLowerCase() ?
//                     <> {process.env.REACT_APP_ASSESSMENTSCORESSHORTLY}</> :<><b>{GetNextExam()}</b> {process.env.REACT_APP_ASSESSMENTSHORTLY}</>}</span>
//                 : <span>{process.env.REACT_APP_OOPS} <b>{props.subjectname}</b> {process.env.REACT_APP_ASSESSMENTAUTOLOAD}
//                     <b>{GetNextExam()}</b> {process.env.REACT_APP_ASSESSMENTSHORTLY}</span>}

//         </div>
//     )
// };
// export default CNFSubmit;
import React, { useState, useEffect } from "react";
import "../Assests/Scss/CNFModel.scss";
import {
  SubjectSubmissionMsgEnglish,
  SubjectSubmissionMsgHindi,
} from "../Reusablecomponents/CustomizedStaticTranslations";
import { useSelector } from "react-redux";
import { CheckLanguage } from "../../ReusableComponents/CommonFunctions";

const CNFSubmit = (props) => {
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [WindowTime, SetWindowTime] = useState(0);
  const SubmitTest = () => {
    if (navigator.onLine) {
      props.ConformModelCLose(false);
    }
  };
  if (WindowTime === parseInt(process.env.REACT_APP_NEXTPAPERLOADINGTIME)) {
    SubmitTest();
    props.changExam();
  }
  useEffect(() => {
    const interval = setInterval(() => {
      SetWindowTime((prevSeconds) => {
        const newSeconds = prevSeconds + 1;
        return newSeconds;
      });
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const GetNextExam = () => {
    switch (props.subjectname) {
      case AssessmentData.subject1Name:
        return `${AssessmentData.subject2Name}`;
      case AssessmentData.subject2Name:
        return `${AssessmentData.subject3Name}`;
      default:
        return "";
    }
  };
  return (
    // <div className="CNFSubmit-mainDiv dflex flexd-column alignitems">
    //     {props.TextRelated ?
    //         <span> {process.env.REACT_APP_ASSESSMENTSUBMIT} <b>{props.subjectname}</b> Assessment. {props.subjectname.toLowerCase() === AssessmentData.subject3Name.toLowerCase() ?
    //             <> {process.env.REACT_APP_ASSESSMENTSCORESSHORTLY}</> :<><b>{GetNextExam()}</b> {process.env.REACT_APP_ASSESSMENTSHORTLY}</>}</span>
    //         : <span>{process.env.REACT_APP_OOPS} <b>{props.subjectname}</b> {process.env.REACT_APP_ASSESSMENTAUTOLOAD}
    //             <b>{GetNextExam()}</b> {process.env.REACT_APP_ASSESSMENTSHORTLY}</span>}
    // </div>

    <div className="CNFSubmit-mainDiv dflex flexd-column alignitems">
      {CheckLanguage(items?.mediumId)
        ? SubjectSubmissionMsgHindi(
            props.TextRelated,
            props.subjectname,
            props.FinialSubject,
            // AssessmentData.subject3Name,
           props.NextSubject || GetNextExam()
          )
        : SubjectSubmissionMsgEnglish(
            props.TextRelated,
            props.subjectname,
            props.FinialSubject,
            // AssessmentData.subject3Name,
           props.NextSubject || GetNextExam()
          )}
    </div>
  );
};
export default CNFSubmit;
